import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'ng-casto-card-type-choice',
  templateUrl: './card-type-choice.component.html',
})
export class CardTypeChoiceComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() withPremium: boolean | null = false;
  @Input() withFree: boolean | null = true;

  public readonly premiumCardPrice: string = '9.90';

  ngOnInit(): void {
    //Si on affiche pas de carte premium, on affiche la carte gratuite, selectionnée par défaut
    if (!this.withPremium) this.form.get('cardIsPremium').setValue(false);
  }
}
